import $ from 'jquery';

import ModalFactory from 'chairisher/factory/modal';

import { trackSmsModalClose } from 'chairisher/analytics/sms';
import { isIdentified } from 'chairisher/context/auth';
import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { hasSubmittedSmsData } from 'chairisher/context/sms';
import { isExperimentVariantB, isExperimentVariantC } from 'chairisher/thirdparty/experiments';
import { handleAsyncError } from 'chairisher/util/logging';
import { isViewerFromIneligibleMarketingReferrer } from 'chairisher/view/helper/marketingpromo';

/**
 * Form that blocks usage of the site and collects sms numbers when the
 * viewer is not logged in.
 */
export default class SmsModal {
    /**
     * Shows the modal
     * This only works when the attentive tracking pixel is loaded or there is a modal template
     */
    show() {
        const $deferred = $.Deferred();
        const $smsModalTemplate = $('#js-sms-form-modal-template');

        if (this.shouldDisplay() && $smsModalTemplate.length && isIdentified()) {
            const modalId = 'sms-form-modal';
            const $modal = ModalFactory.createModal(modalId);
            $modal.find('.modal-body').html($smsModalTemplate.html());

            $modal.appendTo(document.body);

            const combinedModalFlag = getAmplitudeExperimentFlagMap().COMBINED_MODAL_COPY;
            if (isExperimentVariantB(combinedModalFlag)) {
                $modal.find('.js-smsmt-bucket-a').addClass('hidden');
                $modal.find('.js-smsmt-bucket-b').removeClass('hidden');
            } else if (isExperimentVariantC(combinedModalFlag)) {
                $modal.find('.js-smsmt-bucket-a').addClass('hidden');
                $modal.find('.js-smsmt-bucket-c').removeClass('hidden');
            }

            // This loads a heavy third party dependency for validating phone numbers.
            // Most sessions will not invoke this modal, so avoid loading it if possible.
            import('chairisher/component/form/sms').then(({ default: SmsForm }) => {
                const smsForm = new SmsForm({
                    formId: `#${modalId}`,
                    submitSuccessCallback() {
                        $modal.modal('hide');
                        const $confirmModal = ModalFactory.createModal('sms-confirm-modal');
                        $confirmModal.find('.modal-body').html($('#js-sms-confirmation-modal-template').html());
                        $confirmModal.appendTo(document.body);

                        if (isExperimentVariantB(combinedModalFlag)) {
                            $confirmModal.find('.js-smsmt-bucket-a').addClass('hidden');
                            $confirmModal.find('.js-smsmt-bucket-b').removeClass('hidden');
                        } else if (isExperimentVariantC(combinedModalFlag)) {
                            $confirmModal.find('.js-smsmt-bucket-a').addClass('hidden');
                            $confirmModal.find('.js-smsmt-bucket-c').removeClass('hidden');
                        }

                        $confirmModal.on('click', '.js-modal-close', (e) => {
                            e.preventDefault();
                            $confirmModal.modal('hide');
                        });

                        $confirmModal.modal('show');
                    },
                });
                smsForm.showForm();
            }, handleAsyncError);

            $modal.on('hidden.bs.modal', () => {
                trackSmsModalClose();
            });

            $modal.modal({
                backdrop: 'static',
                keyboard: false,
                show: true,
            });
            $deferred.resolve();
        } else {
            $deferred.reject(new Error('Action failed: SMS modal not displayed due to unmet conditions.'));
        }

        return $deferred;
    }

    /**
     * Determines if the sms collection form should be displayed.
     * Factors considered are user authentication state, page uri, and if the viewer is already a signed up.
     *
     * @returns {boolean}
     * @private
     */
    shouldDisplay() {
        return !!(isIdentified() && !(hasSubmittedSmsData() || isViewerFromIneligibleMarketingReferrer()));
    }
}
